import type { UnitSlug } from "@/data/units";

export type SiteReview = {
  author: string;
  initials: string;
  rating: 5;
  when: string;
  text: string;
};

export type UnitReviewProfile = {
  slug: UnitSlug;
  rating: number;
  total: number;
  reviews: SiteReview[];
};

/**
 * Depoimentos exibidos no site (conteúdo editorial da Nook).
 * Placeholders adaptados à identidade da marca — substituir por depoimentos
 * reais autorizados antes de publicar.
 */
export const REVIEWS: Record<UnitSlug, UnitReviewProfile> = {
  "recreio-le-gusta": {
    slug: "recreio-le-gusta",
    rating: 5.0,
    total: 6,
    reviews: [
      {
        author: "Ana Carolina Vieira",
        initials: "AC",
        rating: 5,
        when: "Há 11 meses",
        text: "Que academia incrível! Amo apenas chegar e ter um treino exclusivo pra mim, com instrutores extremamente profissionais e com uma energia receptiva que você treina e se sente bem. A Nook com certeza é a melhor academia que já fui.",
      },
      {
        author: "Alexandra Personal",
        initials: "AP",
        rating: 5,
        when: "Há 1 ano",
        text: "Melhor lugar pra treinamento na região. Equipe nota 10, tudo organizado e limpo. Como é por hora marcada, a academia nunca fica lotada, nem nos horários de pico. E o melhor, sempre treinar com um instrutor e nunca fazer aquele mesmo treino que dura 2 meses. Nada de monotonia. A gente sai treinado, acabado e feliz. Ambiente familiar e com uma energia incrível.",
      },
      {
        author: "Maria Fernanda Demberg",
        initials: "MD",
        rating: 5,
        when: "Há 2 anos",
        text: "Quero parabenizar a equipe da Nook Gym pela experiência incrível. O atendimento personalizado, a qualidade dos aparelhos e o profissionalismo dos instrutores fizeram toda a diferença para mim. Senti um cuidado e uma atenção que realmente superaram minhas expectativas. Recomendo a todos que buscam um acompanhamento de excelência.",
      },
      {
        author: "Breno Fortunato",
        initials: "BF",
        rating: 5,
        when: "Há 1 ano",
        text: "Sensacional! Diferente de todas as academias que já fui, profissionais extremamente atenciosos e ambiente sem comentários! Duvido entrar nesse lugar e não querer treinar!",
      },
      {
        author: "Luciane Loureiro",
        initials: "LL",
        rating: 5,
        when: "Há 1 ano",
        text: "Studio com professores de alto nível técnico e atendimento personalizado durante a execução dos treinos. Ideal para quem busca regularidade e evolução, pois com agendamento de horário, a partir das 6h, nos possibilita uma programação.",
      },
      {
        author: "Ana Beatriz Ruffoni",
        initials: "AR",
        rating: 5,
        when: "Há 1 ano",
        text: "O que antes era uma obrigação, hoje com a Nook virou lazer! Profissionais simpáticos e de extrema competência. Sem contar os equipamentos que são super novos e modernos… indico de olhos fechados!",
      },
    ],
  },

  "barra-da-tijuca": {
    slug: "barra-da-tijuca",
    rating: 5.0,
    total: 7,
    reviews: [
      {
        author: "Alexandra Personal",
        initials: "AP",
        rating: 5,
        when: "Há 11 meses",
        text: "Melhor lugar pra treinar na região da Barra da Tijuca. Sempre com acompanhamento, treino exclusivo, um método que eu nunca vi em outra academia. Ambiente agradável, estrutura incrível!",
      },
      {
        author: "Júlia Weibert",
        initials: "JW",
        rating: 5,
        when: "Há 6 meses",
        text: "Academia com estrutura e aparelhos de alta qualidade, ótimos instrutores, ambiente super agradável. O acompanhamento é bem personalizado, em poucos meses evoluí muito mais do que anos treinando. O custo-benefício vale muito a pena!",
      },
      {
        author: "Natália Ichaso",
        initials: "NI",
        rating: 5,
        when: "Há 6 meses",
        text: "A Nook foi a melhor escolha de academia que eu poderia ter feito. Os instrutores são todos muito atenciosos e bem preparados. O clima da academia é excelente. Ir treinar virou a hora favorita do dia.",
      },
      {
        author: "Marcela Accioly Cardoso",
        initials: "MC",
        rating: 5,
        when: "Há 6 meses",
        text: "Academia excepcional! Todos os treinadores e colaboradores são extremamente sociáveis, o que cria um ambiente muito bom de se treinar. Cria-se um verdadeiro sentimento de comunidade de bem-estar!",
      },
      {
        author: "Maria Clara Mascarenhas",
        initials: "MM",
        rating: 5,
        when: "Há 6 meses",
        text: "Um ambiente agradável, animado e gostoso de estar faz toda diferença. Em apenas 3 meses eu já senti mudanças reais — no corpo, na disposição e até na motivação.",
      },
      {
        author: "Luiz Delmas",
        initials: "LD",
        rating: 5,
        when: "Há 6 meses",
        text: "Academia muito boa, aparelhos ótimos! Mas o diferencial é o atendimento tanto dos personais quanto da recepção, os treinos muito bem montados e organizados. Certamente recomendaria para qualquer pessoa.",
      },
      {
        author: "Fernanda Boucas",
        initials: "FB",
        rating: 5,
        when: "Há 6 meses",
        text: "Academia nova, profissionais excelentes e o clima e ambiente é super acolhedor e familiar! Estou há 3 meses na Nook e me parece que estou há anos! Conheçam a Nook.",
      },
    ],
  },

  "recreio-americas": {
    slug: "recreio-americas",
    rating: 5.0,
    total: 6,
    reviews: [
      {
        author: "Cristiane Santos",
        initials: "CS",
        rating: 5,
        when: "Há 7 dias",
        text: "Estou adorando treinar na Nook! A academia é super organizada, linda, os aparelhos são ótimos, novinhos e o ambiente é muito agradável. A equipe é muito atenciosa e sempre pronta para ajudar! Treino Top todos os dias. Dá gosto de vir treinar! Recomendo demais para quem procura treino personalizado, focado e de qualidade.",
      },
      {
        author: "Fernando Sanches",
        initials: "FS",
        rating: 5,
        when: "Há 7 dias",
        text: "Sem dúvida a melhor opção se você não quer ficar dividindo aparelho escutando música ruim e treinando em ambiente ruim. Você precisa conhecer a Nook: ótima academia, estrutura maravilhosa, pessoas incríveis e ter o acompanhamento de um profissional em todos os treinos é um ótimo diferencial. Obs: o café é incrível.",
      },
      {
        author: "Gabriela Fernandes",
        initials: "GF",
        rating: 5,
        when: "Há 6 dias",
        text: "Ambiente amplo e espetacular! Profissionais super atenciosos, cantinho para tomar café que eu sou fã e equipamentos de qualidade super novos.",
      },
      {
        author: "Ludimylla Andrade",
        initials: "LA",
        rating: 5,
        when: "Há 6 dias",
        text: "Todos prestam um excelente atendimento: a recepção, os instrutores. Espaço devidamente climatizado e com ótimos aparelhos. Treino personalizado de acordo com a necessidade do aluno.",
      },
      {
        author: "Leonardo Pereira Pacheco",
        initials: "LP",
        rating: 5,
        when: "Há 7 dias",
        text: "Atendimento de excelência, profissionais dedicados, respeitosos e atenciosos. Além de ter uma estrutura padrão para treinos!!!",
      },
      {
        author: "Danielle Evelen",
        initials: "DE",
        rating: 5,
        when: "Há 7 dias",
        text: "Ambiente maravilhoso, profissionais super capacitados e simpáticos. Me senti acolhida, amei!",
      },
    ],
  },
};
